import { Link, useSearchParams } from "react-router-dom";
import { Icon } from "@/components/Icon/Icon";
import { SubmitButton } from "../parts/SubmitButton";
import { useForgotPasswordFlow } from "./useForgotPasswordFlow";

export function ForgotPasswordForm() {
  const [params] = useSearchParams();
  const initialEmail = params.get("email") ?? "";
  const flow = useForgotPasswordFlow(initialEmail);

  const disabled = flow.pending !== "none";

  if (flow.stage === "send-code") {
    return (
      <form onSubmit={flow.sendCode}>
        <div className="signin-field">
          <label className="signin-field-label" htmlFor="forgot-email">Email</label>
          <input
            id="forgot-email"
            className={`signin-field-input${flow.fieldError ? " signin-field-input--error" : ""}`}
            type="email"
            autoComplete="email"
            placeholder="you@company.com"
            value={flow.email}
            onChange={(e) => flow.setEmail(e.target.value)}
            required
          />
          {flow.fieldError && <div className="signin-error">{flow.fieldError}</div>}
        </div>
        {flow.formError && <div className="signin-error">{flow.formError}</div>}
        <SubmitButton
          pending={flow.pending === "sending"}
          disabled={disabled}
          pendingLabel="Sending…"
        >
          Send reset code
        </SubmitButton>
        <div style={{ marginTop: 18, textAlign: "center" }}>
          <Link to="/sign-in/split" className="signin-forgot">
            <Icon name="arrow-l" size={13} /> Back to sign-in
          </Link>
        </div>
      </form>
    );
  }

  if (flow.stage === "verify-code") {
    return (
      <form onSubmit={flow.verifyCode}>
        <p className="signin-centered-lede">
          We sent a code to <strong>{flow.email}</strong>. Enter it below.
        </p>
        <div className="signin-field">
          <label className="signin-field-label" htmlFor="forgot-code">Reset code</label>
          <input
            id="forgot-code"
            className={`signin-field-input${flow.fieldError ? " signin-field-input--error" : ""}`}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="123456"
            value={flow.code}
            onChange={(e) => flow.setCode(e.target.value)}
            required
          />
          {flow.fieldError && <div className="signin-error">{flow.fieldError}</div>}
        </div>
        {flow.formError && <div className="signin-error">{flow.formError}</div>}
        <SubmitButton
          pending={flow.pending === "verifying"}
          disabled={disabled}
          pendingLabel="Verifying…"
        >
          Verify code
        </SubmitButton>
      </form>
    );
  }

  if (flow.stage === "set-password") {
    return (
      <form onSubmit={flow.submitPassword}>
        <div className="signin-field">
          <label className="signin-field-label" htmlFor="forgot-new-password">
            New password
          </label>
          <input
            id="forgot-new-password"
            className={`signin-field-input${flow.fieldError ? " signin-field-input--error" : ""}`}
            type="password"
            autoComplete="new-password"
            placeholder="••••••••"
            value={flow.password}
            onChange={(e) => flow.setPassword(e.target.value)}
            required
            minLength={8}
          />
          {flow.fieldError && <div className="signin-error">{flow.fieldError}</div>}
        </div>
        {flow.formError && <div className="signin-error">{flow.formError}</div>}
        <SubmitButton
          pending={flow.pending === "submitting"}
          disabled={disabled}
          pendingLabel="Setting password…"
        >
          Set new password
        </SubmitButton>
      </form>
    );
  }

  return (
    <div className="signin-centered-lede">
      Password updated. Redirecting…
    </div>
  );
}
